/**
 * Full-cook recipes - Full spread with main + sides
 * ~10 recipes for when you have time and energy
 */

const FULL_COOK_RECIPES = [
  {
    id: 'roast-chicken',
    name: 'Roast Chicken Dinner',
    effort: 'full-cook',
    needs: ['whole chicken', 'potato', 'veg'],
    optional: ['garlic', 'lemon', 'herbs', 'gravy'],
    description: 'Sunday roast classic',
    tips: 'Rest chicken 15 min before carving'
  },
  {
    id: 'lasagna',
    name: 'Lasagna',
    effort: 'full-cook',
    needs: ['pasta sheets', 'ground beef', 'tomato sauce', 'cheese'],
    optional: ['bechamel', 'onion', 'garlic', 'herbs'],
    description: 'Layered Italian comfort',
    tips: 'Let rest 10 min for cleaner slices'
  },
  {
    id: 'homemade-pizza',
    name: 'Homemade Pizza',
    effort: 'full-cook',
    needs: ['flour', 'yeast', 'tomato sauce', 'cheese'],
    optional: ['pepperoni', 'mushroom', 'peppers', 'olives'],
    description: 'From scratch pizza night',
    tips: 'Hottest oven possible, thin base'
  },
  {
    id: 'beef-stew',
    name: 'Beef Stew',
    effort: 'full-cook',
    needs: ['beef', 'potato', 'carrot', 'stock'],
    optional: ['onion', 'celery', 'wine', 'herbs'],
    description: 'Low and slow comfort',
    tips: 'Brown meat well for depth of flavor'
  },
  {
    id: 'shepherd-pie',
    name: 'Shepherd\'s Pie',
    effort: 'full-cook',
    needs: ['ground lamb', 'potato', 'carrot', 'onion'],
    optional: ['peas', 'stock', 'worcestershire', 'cheese'],
    description: 'Meat and mash in one dish',
    tips: 'Rough up mash top for crispy bits'
  },
  {
    id: 'chicken-parmesan',
    name: 'Chicken Parmesan',
    effort: 'full-cook',
    needs: ['chicken', 'breadcrumbs', 'tomato sauce', 'mozzarella'],
    optional: ['parmesan', 'pasta', 'basil', 'garlic'],
    description: 'Italian-American favorite',
    tips: 'Pound chicken thin for even cooking'
  },
  {
    id: 'pot-roast',
    name: 'Pot Roast',
    effort: 'full-cook',
    needs: ['beef roast', 'potato', 'carrot', 'onion'],
    optional: ['celery', 'stock', 'wine', 'herbs'],
    description: 'Fall-apart tender beef',
    tips: 'Low heat, long time, don\'t peek'
  },
  {
    id: 'enchiladas',
    name: 'Enchiladas',
    effort: 'full-cook',
    needs: ['tortilla', 'chicken', 'enchilada sauce', 'cheese'],
    optional: ['beans', 'sour cream', 'onion', 'cilantro'],
    description: 'Rolled, sauced, and baked',
    tips: 'Warm tortillas so they don\'t crack'
  },
  {
    id: 'fish-chips',
    name: 'Fish & Chips',
    effort: 'full-cook',
    needs: ['white fish', 'potato', 'flour', 'oil'],
    optional: ['beer', 'peas', 'tartar sauce', 'lemon'],
    description: 'British chippy at home',
    tips: 'Double-fry chips for extra crisp'
  },
  {
    id: 'stuffed-peppers',
    name: 'Stuffed Peppers',
    effort: 'full-cook',
    needs: ['peppers', 'ground beef', 'rice', 'tomato sauce'],
    optional: ['cheese', 'onion', 'garlic', 'herbs'],
    description: 'Complete meal in a pepper',
    tips: 'Par-cook peppers for even doneness'
  },
  // === ADDITIONAL PROTEIN OPTIONS ===
  {
    id: 'pork-chops-dinner',
    name: 'Pork Chops Dinner',
    effort: 'full-cook',
    needs: ['pork chop', 'potato', 'veg'],
    optional: ['garlic', 'herbs', 'apple sauce', 'gravy'],
    description: 'Pan-seared chops with sides',
    tips: 'Rest chops 5 min after cooking'
  },
  {
    id: 'turkey-roast',
    name: 'Roast Turkey Breast',
    effort: 'full-cook',
    needs: ['turkey breast', 'potato', 'veg'],
    optional: ['garlic', 'herbs', 'gravy', 'stuffing'],
    description: 'Weeknight roast without whole bird',
    tips: 'Use meat thermometer - 165°F internal'
  },
  {
    id: 'baked-tofu-bowl',
    name: 'Baked Tofu Bowl',
    effort: 'full-cook',
    needs: ['tofu', 'rice', 'veg', 'soy sauce'],
    optional: ['sesame oil', 'garlic', 'ginger', 'green onion'],
    description: 'Crispy baked tofu with grain bowl',
    tips: 'Press tofu well, bake at high heat'
  },
  {
    id: 'veggie-stuffed-peppers',
    name: 'Veggie Stuffed Peppers',
    effort: 'full-cook',
    needs: ['peppers', 'rice', 'beans', 'tomato sauce'],
    optional: ['cheese', 'corn', 'onion', 'cumin'],
    description: 'Vegetarian stuffed peppers',
    tips: 'Black beans and corn work great'
  },
  {
    id: 'lamb-shanks',
    name: 'Braised Lamb Shanks',
    effort: 'full-cook',
    needs: ['lamb shank', 'onion', 'carrot', 'stock'],
    optional: ['wine', 'tomato', 'herbs', 'garlic'],
    description: 'Fall-off-the-bone tender',
    tips: 'Low and slow - 2-3 hours'
  },
  {
    id: 'salmon-dinner',
    name: 'Roasted Salmon Dinner',
    effort: 'full-cook',
    needs: ['salmon', 'potato', 'veg'],
    optional: ['lemon', 'dill', 'garlic', 'olive oil'],
    description: 'Sheet pan salmon with roasted veg',
    tips: 'Add salmon halfway through veg roasting'
  }
];

export default FULL_COOK_RECIPES;
